import React, { useState, useRef } from "react";
import { Link } from 'react-router-dom';

import styles from "./Topbar.module.scss";
import { FormattedMessage, useIntl } from "react-intl";
import PopUp from "../popUp/PopUp"
import useOutsideClick from "../outsideClick/useOutsideClick";
import OprorPdf from "../../images/oprorWhitePaper.pdf";

// import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';

function Topbar() {
  const [isSeen, setSeen] = useState(false);
  const [isActive, setActive] = useState(false);
  const ref = useRef();

  useOutsideClick(ref, () => {
    setActive(false);
  });

  const downloadPaper = () => {
    fetch(OprorPdf).then(response => {
      response.blob().then(blob => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = 'Opror.pdf';
        alink.click();
      })
    })
  };

  return (
    <div className={styles.main}>
      <div className={styles.fixedMain}>
        <div className={styles.wrap}>
          <Link to={"/"} className={styles.logoWrap}>
            <div className={styles.logo} />
          </Link>

          <div className={styles.navWrap}>
            <Link to={"/media"} className={styles.squarelessBtn}>
              <span><FormattedMessage id="media" /></span>
            </Link>
            {/*<Link to={"/news"} className={styles.squarelessBtn}>
              <span><FormattedMessage id="news"/></span>
            </Link>*/}
            <Link to={"/aboutUs"} className={styles.squarelessBtn}>
              <span><FormattedMessage id="aboutUs" /></span>
            </Link>
            <Link to={"/faq"} className={styles.squarelessBtn}>
              <span><FormattedMessage id="faq" /></span>
            </Link>
          </div>
        </div>

        <div className={styles.wrapMobile} ref={ref}>
          <div className={styles.containerMobile}>
            <Link to={"/"} className={styles.logoWrap}>
              <div className={styles.logo} />
            </Link>
            <button
              type="button"
              className={styles.menuMobile}
              onClick={() => setActive(!isActive)}
              aria-expanded={isActive}
              aria-label="Toggle menu"
            />
          </div>
        </div>
      </div>

      {isActive ? (
        <div className={styles.menuBox}>
          <Link to={"/media"} className={styles.mobileBtn}>
            <span><FormattedMessage id="media" /></span>
          </Link>
          {/*<Link to={"/news"} className={styles.mobileBtn}>
            <span><FormattedMessage id="news"/></span>
          </Link>*/}
          <Link to={"/aboutUs"} className={styles.mobileBtn}>
            <span><FormattedMessage id="aboutUs" /></span>
          </Link>
          <Link to={"/faq"} className={styles.mobileBtn}>
            <span><FormattedMessage id="faq" /></span>
          </Link>
        </div>
      ) : null}

      {isSeen ? (
        <PopUp toggleClose={() => setSeen(!isSeen)} />
      ) : null}
    </div>
  );
}

export default Topbar;